import { Anchor, Box, Heading } from '@zillow/constellation-10';

import { PartialMessage } from '@zg-rentals/backend-styled-components';

import type { ComponentProps } from 'react';

import { useGetHelpArticles } from '../../hooks/queries/support';

const HelpArticleAnchor = (props: ComponentProps<typeof Anchor>) => (
  <Anchor {...props} css={{ color: 'black !important' }} />
);

import type {
  GuestSupportGetHelpTopicsCategoryTopicWebDto,
  GuestSupportGetHelpTopicsCategoryWebDto,
  RentalManagerSupportHelpArticleResponseDto,
} from '@zg-rentals/ts-rental-manager-api-client';

type Props = {
  selectedHelpCategory: GuestSupportGetHelpTopicsCategoryWebDto;
  selectedHelpTopic: GuestSupportGetHelpTopicsCategoryTopicWebDto;
  isLoggedIn: boolean;
};

const HelpArticlesContent = ({ selectedHelpCategory, selectedHelpTopic, isLoggedIn }: Props) => {
  const { data: helpArticlesData, error: helpArticlesError } = useGetHelpArticles({
    category: selectedHelpCategory?.key || '',
    topic: selectedHelpTopic?.key || '',
    isLoggedIn,
  });

  //  if there is an error just don't show the articles section
  if (helpArticlesError || !helpArticlesData) return null;

  const renderHelpArticle = (helpArticle: RentalManagerSupportHelpArticleResponseDto) => {
    const { title, contents } = helpArticle;

    return (
      <>
        <Box css={{ marginBottom: '200' }}>
          <PartialMessage partialMessages={title} linkComponent={HelpArticleAnchor} fontType="body-sm" />
        </Box>
        {contents?.length > 0 && (
          <Box css={{ marginBottom: '600' }}>
            {contents?.map((c, i) => {
              return (
                <PartialMessage
                  key={`help-article-contents-${i}`}
                  partialMessages={c}
                  linkComponent={HelpArticleAnchor}
                  fontType="body-sm"
                />
              );
            })}
          </Box>
        )}
      </>
    );
  };

  return (
    <Box data-testid="HelpArticles" css={{ marginLeft: { base: 0, xl: '1200' }, marginTop: { base: '800', xl: 0 } }}>
      {helpArticlesData?.heading && (
        <Heading level={6} css={{ marginBottom: '600' }}>
          {helpArticlesData?.heading}
        </Heading>
      )}
      {helpArticlesData?.helpArticles?.map((helpArticle: RentalManagerSupportHelpArticleResponseDto, i: number) => {
        return <div key={`help-article-${i}`}>{renderHelpArticle(helpArticle)}</div>;
      })}
    </Box>
  );
};

export default HelpArticlesContent;
